export const sleep = (ms = 0) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

/** Validation */
export const validators = {
  email: (v: string | undefined) => {
    if (!v || !v.trim()) {
      return true // không có dữ liệu => bỏ qua
    }
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return pattern.test(v) || 'Vui lòng nhập email hợp lệ'
  },
  required: (v: any) => !!v || 'Trường này là bắt buộc',
  requiredArray: (v: any) => (Array.isArray(v) && v.length > 0) || 'Trường này là bắt buộc',
  maxLength: (max: number) => (v: any) => !v || v.length <= max || `Không được vượt quá ${max} ký tự`,
  number: (v: any) => {
    if (v === null || v === undefined || v === '') {
      return true // không có dữ liệu => bỏ qua
    }
    // Hợp lệ nếu là số nguyên hoặc số thập phân
    const pattern = /^-?\d+(\.\d+)?$/
    return pattern.test(String(v)) || 'Vui lòng nhập số hợp lệ'
  },

  // Nghiep vu
  containerNumberRule: (value: string) => {
    if (!value) return true // để rule required xử lý
    return /^[A-Z]{4}\d{7}$/.test(value) || 'Số container phải có dạng 4 chữ + 7 số (VD: TLLU1041361)'
  },
  vietnamLicensePlateRule: (value: string) => {
    if (!value) return true // để required xử lý
    return /^\d{2}[A-Z] \d{5}$/.test(value) || 'Biển số xe cần đúng định dạng (VD: 99H 06150)'
  },
}

export const generatePassword = (length = 8) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}

export const downloadFromResponse = (response: any, defaultName = 'export.xlsx') => {
  const blob = new Blob([response.data])
  const url = window.URL.createObjectURL(blob)

  let fileName = defaultName
  const disposition = response.headers['content-disposition']

  if (disposition) {
    const match = disposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';\r\n]+)/)
    if (match?.[1]) {
      fileName = decodeURIComponent(match[1].trim())
    }
  }

  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()

  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}
